const variantMap = {
  'stainless steel / 6 bar spring / 120v / ash': '53045693514040',
  'stainless steel / 6 bar spring / 120v / walnut': '53054091460920',
  'stainless steel / 8 bar spring / 120v / ash': '53045693546808',
  'stainless steel / 8 bar spring / 120v / walnut': '53054091493688',
  'stainless steel / direct / 120v / ash': '53045693579576',
  'stainless steel / direct / 120v / walnut': '53054091526456',
  'stainless steel / 6 bar spring / 240v / ash': '53045693612344',
  'stainless steel / 6 bar spring / 240v / walnut': '53054091559224',
  'stainless steel / 8 bar spring / 240v / ash': '53045693645112',
  'stainless steel / 8 bar spring / 240v / walnut': '53054091591992',
  'stainless steel / direct / 240v / ash': '53045693677880',
  'stainless steel / direct / 240v / walnut': '53054091624760',
  'matte black / 6 bar spring / 120v / ash': '53045694300472',
  'matte black / 6 bar spring / 120v / walnut': '53054091657528',
  'matte black / 8 bar spring / 120v / ash': '53045694333240',
  'matte black / 8 bar spring / 120v / walnut': '53054091690296',
  'matte black / direct / 120v / ash': '53045694366008',
  'matte black / direct / 120v / walnut': '53054091723064',
  'matte black / 6 bar spring / 240v / ash': '53045694398776',
  'matte black / 6 bar spring / 240v / walnut': '53054091755832',
  'matte black / 8 bar spring / 240v / ash': '53045694431544',
  'matte black / 8 bar spring / 240v / walnut': '53054091788600',
  'matte black / direct / 240v / ash': '53045694464312',
  'matte black / direct / 240v / walnut': '53054091821368',
  'matte white / 6 bar spring / 120v / ash': '53045695086904',
  'matte white / 6 bar spring / 120v / walnut': '53054091854136',
  'matte white / 8 bar spring / 120v / ash': '53045695119672',
  'matte white / 8 bar spring / 120v / walnut': '53054091886904',
  'matte white / direct / 120v / ash': '53045695152440',
  'matte white / direct / 120v / walnut': '53054091919672',
  'matte white / 6 bar spring / 240v / ash': '53045695185208',
  'matte white / 6 bar spring / 240v / walnut': '53054091952440',
  'matte white / 8 bar spring / 240v / ash': '53045695217976',
  'matte white / 8 bar spring / 240v / walnut': '53054091985208',
  'matte white / direct / 240v / ash': '53045695250744',
  'matte white / direct / 240v / walnut': '53054092017976',
};

function getSelectedVariant() {
  const variantJson = document.querySelector('script[data-selected-variant]');

  if (!variantJson) return null;
  return JSON.parse(variantJson.textContent);
}

function loadInitialSelection() {
  let selectedVariant = getSelectedVariant();

  let voltage = selectedVariant.title.toLowerCase().includes('120v') ? '120v' : '240v';
  let woodAccent = selectedVariant.title.toLowerCase().includes('ash') ? 'ash' : 'walnut';
  let is6Bar = selectedVariant.title.toLowerCase().includes('6 bar');
  let is8Bar = selectedVariant.title.toLowerCase().includes('8 bar');
  if (is6Bar) {
    document.querySelector(`input[id=lever-configuration-6-bar-spring]`).checked = true;
  } else if (is8Bar) {
    document.querySelector(`input[id=lever-configuration-8-bar-spring]`).checked = true;
  } else {
    document.querySelector(`input[id=lever-configuration-direct]`).checked = true;
  }

  let isBlack = selectedVariant.title.toLowerCase().includes('matte black');
  let isWhite = selectedVariant.title.toLowerCase().includes('matte white');
  let colorLabel = document.querySelector("input[name='color']").parentElement.querySelector('legend > span');
  if (isBlack) {
    document.querySelector(`input[id=color-matte-black]`).checked = true;
    colorLabel.textContent = 'Matte Black';
  } else if (isWhite) {
    document.querySelector(`input[id=color-matte-white]`).checked = true;
    colorLabel.textContent = 'Matte White';
  } else {
    document.querySelector(`input[id=color-stainless-steel]`).checked = true;
    colorLabel.textContent = 'Stainless Steel';
  }

  document.querySelector(`input[id=voltage-${voltage}]`).checked = true;
  document.querySelector(`input[id=wood-accent-${woodAccent}]`).checked = true;
}

function getSelectedValue(radioName) {
  let radioButtons = document.querySelectorAll(`input[name=${radioName}]`);
  let selected;
  radioButtons.forEach((radio) => {
    if (radio.checked) selected = radio.value;
  });
  return selected;
}

window.addEventListener('pageshow', () => {
  // on browser nav, make sure we have the correct variants selected
  loadInitialSelection();
});

window.addEventListener('DOMContentLoaded', () => {
  loadInitialSelection();

  function navigateToProduct() {
    let color = getSelectedValue('color');
    let voltage = getSelectedValue('voltage');
    let woodAccent = getSelectedValue('wood-accent');
    let leverConfiguration = getSelectedValue('lever-configuration');

    // This product's native Shopify options are Color, Wood, and a combined
    // "Lever and Voltage" option (e.g. "6 Bar Spring / 120V") - only 3 real
    // options, since Shopify variant titles are just all option values joined
    // by " / ", and one of those values itself contains a "/".
    let leverVoltage = `${leverConfiguration} / ${voltage}`;

    let variantSelector = document.querySelector('variant-selects');
    variantSelector.querySelector(`input[value="${leverVoltage}"]`).click();
    variantSelector.querySelector(`input[value="${woodAccent}"]`).click();

    let colorElement = variantSelector.querySelector(`input[value="${color}"]`);
    document.querySelector("input[name='color']").parentElement.querySelector('legend > span').textContent = color;
    colorElement.click();
  }

  let inputs = document.querySelectorAll(
    'input[name=color], input[name=voltage], input[name=wood-accent], input[name=lever-configuration]'
  );
  inputs.forEach((input) => {
    input.addEventListener('click', () => {
      navigateToProduct();
    });
  });
});
